module.exports = "/_next/static/images/Hero@2x-e0b5786f0f08ef1b0cf3d9a829815607.webp";